import request from '@/config/axios'

export interface FirmSettleApplyVO {
  id: number
  applyNo?: string
  firmId?: number
  firmName?: string
  amount?: number
  orderCount?: number
  periodStart?: string
  periodEnd?: string
  status?: string
  remark?: string
  auditRemark?: string
  handleTime?: string
  createTime?: string
}

export interface FirmSettleApplyPageReqVO {
  pageNo?: number
  pageSize?: number
  firmId?: number
  status?: string
}

export const FirmSettleApplyApi = {
  getPage: async (params: FirmSettleApplyPageReqVO) => {
    return await request.get<{ list: FirmSettleApplyVO[]; total: number }>({
      url: '/lawyer/firm-settle-apply/page',
      params
    })
  },
  audit: async (data: { id: number; status: string; auditRemark?: string }) => {
    return await request.post({ url: '/lawyer/firm-settle-apply/audit', data })
  },
  getWallet: async (firmId: number) => {
    return await request.get<FirmSettleWalletVO>({
      url: '/lawyer/firm-settle-apply/wallet',
      params: { firmId }
    })
  },
  payout: async (data: { applyId: number; orderIds?: number[] }) => {
    return await request.post<FirmSettlePayoutResultVO>({
      url: '/lawyer/firm-settle-apply/payout',
      data
    })
  }
}

export interface FirmSettleWalletVO {
  firmId?: number
  availableBalance?: number
  frozenBalance?: number
  totalIn?: number
  totalOut?: number
  retainRate?: number
}

export interface FirmSettlePayoutResultVO {
  paidCount?: number
  skippedCount?: number
}
